<template>
  <div class="outBox scrollStyle">
    <!-- <transition name="left"> -->
    <div class="quotaBox" v-if="isShowQuato">
      <div class="title">
        <!-- <button @click="ceshi">按钮</button> -->
        <h2>我的额度</h2>
      </div>
      <div class="talksBox scrollStyle">
        <Msg :news="msgOne"></Msg>
        <div v-for="(item, index) in goodsOptions" :key="index">
          <Msg 
            :news="item" 
            :isAction="true" 
            @payGood="payGood" 
            actionText="我要充值"
          >
          </Msg>
        </div>
      </div>
      <!-- <div class="title titleFlex" @click="isShowTask = !isShowTask">
        <h2>任务</h2>
        <div class="titleIconBox">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div> -->
      <div class="title titleFlex" @click="isShowBuysData = !isShowBuysData">
        <h2>充值记录</h2>
        <div class="titleIconBox">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <!-- <div class="title titleFlex" @click="isShowSignIn = !isShowSignIn">
        <h2>签到</h2>
        <div class="titleIconBox">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div> -->
      <!-- <div class="talksBox">
        <template v-if="buysData.length">
          <div class="payCard" v-for="(item, index) in buysData" :key="index">
            <div class="repordNum">订单号：{{ item.orderNo }}</div>
            <div class="repordContent">
              <el-row>
                <el-col :span="12">充值金额：￥{{ item.amount }}</el-col>
                <el-col :span="12">充值额度：{{ item.number }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">充值时间：{{ item.createdTime }}</el-col>
                <el-col :span="12">过期时间：{{ item.expires }}</el-col>
              </el-row>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty description="暂无数据"></el-empty>
        </template>
      </div> -->
    </div>
    <!-- </transition> -->

    <!-- 任务 -->
    <transition name="fade">
      <div class="rightBox" v-if="isShowTask">
        <Tasks @goBack="isShowTask = false"></Tasks>
      </div>
    </transition>
    <!-- <div class=""> -->
      <!-- 充值记录 -->
    <transition name="fade">
      <div class="rightBox" v-if="isShowBuysData">
        <BuysData @goBack="isShowBuysData = false"></BuysData>
      </div>
    </transition>
    <!-- 签到 -->
    <transition name="fade">
      <div class="rightBox" v-if="isShowSignIn">
        <SignIn @goBack="isShowSignIn = false"></SignIn>
      </div>
    </transition>
    <!-- </div> -->
    <!-- 充值 -->
    <el-dialog
      width="624px"
      title="充值"
      :visible.sync="dialogNumberVisible"
      @close="isQuery = false"
      :fullscreen="isMobile ? true : false"
    >
      <div class="pay-success" v-if="paySuccess">
        <img src="@/assets/img/recharge_success.svg" />
        <div>恭喜您~ 充值成功</div>
        <el-button
          type="primary"
          size="medium"
          plain
          @click="dialogNumberVisible = false"
          >关闭</el-button
        >
      </div>

      <div v-if="order" style="text-align: center">
        <div class="pay-text" v-if="paySuccess == false">
          {{ payText }}
        </div>
        <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="二维码" />
        <div>
          <el-button
            type="primary"
            plain
            @click="queryOrder"
            v-if="isQuery == false && paySuccess == false"
            >我已支付</el-button
          >
          <p v-if="isQuery">订单查询中...</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import config from "@/config";
import util from "@/utils/utils";
import QRCode from "qrcode";
import Msg from '../+components/Msg';
import BuysData from "./buysData.vue";
import Tasks from './tasks.vue';
import SignIn from './signIn.vue';
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'Quota',
  components: { Msg, BuysData, Tasks, SignIn },
  props: {},
  data () {
    return {
      GetGoodsList: api.GetGoodsList,
      createOrder: api.createOrder,
      getState: api.getState,
      getUserInfo: api.getUserInfo,
      getOrders: api.getOrders,
      goodsOptions: [],
      Infinite: -1,
      isQuery: false,
      paySuccess: false,
      payText: "", //微信提示
      qrCodeUrl: "",
      order: null,
      dialogNumberVisible: false,
      // buysData: [], // 充值记录
      isShowBuysData: false, // 是否展示充值记录
      isShowTask: false, // 是否展示任务
      isShowSignIn: false, // 是展示签到
      isMobile: config.isMobile, // 是否移动端
    }
  },
  computed: {
    ...mapState('userAbout', ['user']),
    msgOne() {
      const textTitle = `剩余额度：${this.user.number == this.Infinite ? "不限" : (this.user.number || 0) + "条"}`;
      const textContent = this.user.expires || "[无有效额度]"
      return {
        avatarText: {
          text: 'M',
          background: '#ffc107',
        },
        textTitle,
        textContent: '有效时间：' + textContent,
      }
    },
    isShowQuato() {
      return !this.isShowBuysData && !this.isShowTask && !this.isShowSignIn;
    },
  },
  watch: {},
  created () {},
  mounted () {
    this.toGetGoodsList();
    // this.toGetOrders();
  },
  methods: {
    ...mapMutations('userAbout', ['setUser']),
    ceshi() {
      console.log(config);
    },
    //获取充值记录
    // toGetOrders() {
    //   // this.loading = true;
    //   this.getOrders()
    //     .then((res) => {
    //       console.log(res.data);
    //       if (res.success) {
    //         this.buysData = res.data.map((p) => ({
    //           ...p,
    //           number: p.number == this.Infinite ? "不限" : p.number.toString(),
    //         }));
    //       }
    //       // this.loading = false;
    //     })
    //     .catch((e) => {
    //       // this.loading = false;
    //     });
    // },
    // 充值
    payGood(val){
      // 打开弹出框
      this.dialogNumberVisible = true;

      const param = {
        goodsId: val.id,
        type: 1
      };
      let payType = 1; //（1：二维码扫码；2：微信浏览器）
      let wxInnerPay = config.isMobile && util.isWechat();
      if (wxInnerPay) {
        payType = 2;
      }
      param.payType = payType;

      try {
        // this.loading = true;
        this.createOrder(param)
          .then((res) => {
            if (res.success) {
              this.order = res.data;

              //根据当前是pc端还是微信端
              this.handleClientPay(res, wxInnerPay);

              //定时查询订单状态
              this.isQuery = false;
              this.paySuccess = false;
            } else {
              this.$message.error("充值错误：" + res.message);
            }
            // this.loading = false;
          })
          .catch((e) => {
            // this.loading = false;
          });
      } catch (error) {
        console.error(error);
      }
    },
    //获取商品
    toGetGoodsList() {
      // this.loading = true;
      this.GetGoodsList({})
        .then((res) => {
          if (res.success) {
            this.goodsOptions = res.data.map(item => {
              const text = item.duration === 7 ? '周' : (item.duration === 30) ? '月' : '天'
              const avatarText = {
                text,
                background: '#007bff',
              };
              const textTitle = 
                text === '天' ? `￥${item.price}/${item.duration}天` : `￥${item.price}/${text}`;
              const textContent = item.productName;
              return { ...item, avatarText, textTitle, textContent };
            });
          }
          // this.loading = false;
        })
        .catch((e) => {
          // this.loading = false;
        });
    },
    //处理不同客户端
    handleClientPay(res, wxInnerPay) {
      if (!wxInnerPay) {
        //非微信浏览器
        this.generateQRCode(res.data.url);
        if (config.isMobile) {
          this.payText =
            "请使用微信扫码完成支付，或将网页地址在微信中打开重新下单支付。";
        } else {
          this.payText = "请使用微信扫码完成支付";
        }
      } else {
        //微信浏览器
        this.payText = "请在微信上完成支付";
        this.callWXPay(res.data.payInfo);
      }
    },
    //生成二维码
    async generateQRCode(qrCodeUrl) {
      try {
        const canvas = await QRCode.toCanvas(qrCodeUrl, { width: 200 });
        this.qrCodeUrl = canvas.toDataURL();
      } catch (error) {
        console.error(error);
      }
    },
    //调起微信支付
    callWXPay(payInfo) {
      //debugger;
      var that = this;
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: payInfo.appId, //公众号ID，由商户传入
            timeStamp: payInfo.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: payInfo.nonceStr, //随机串
            package: payInfo.package,
            signType: payInfo.signType, //微信签名方式：
            paySign: payInfo.paySign,
          },
          function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.queryOrder();
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    },
    //我已支付
    queryOrder() {
      if (this.isQuery == true) {
        return;
      }
      this.isQuery = true;

      var that = this;
      var query = () => {
        that
          .getState({
            orderNo: that.order.orderNo,
          })
          .then((res) => {
            if (res.success) {
              if (res.data == 2) {
                that.isQuery = false;
                that.paySuccess = true;
                that.getLatelyUserInfo();
                that.qrCodeUrl = "";
              } else {
                setTimeout(() => {
                  if (that.isQuery == true) {
                    query();
                  }
                }, 3000);
              }
            }
          })
          .catch((e) => {
            //that.loading = false;
          });
      };
      query();
    },
    //获取最新用户信息
    getLatelyUserInfo() {
      // this.loading = true;
      this.getUserInfo()
        .then((res) => {
          if (res.data != null) {
            this.setUser(res.data);
          }
          // this.loading = false;
        })
        .catch((e) => {
          // this.loading = false;
        });
    },
  }
}
</script>

<style scoped lang="less">
.outBox {
  display: flex;
  // overflow: hidden;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  // 右侧展开收起动画
  .fade-enter-active, .fade-leave-active {
    transition: all .3s ease-out;
  }
  .fade-enter-to , .fade-leave/* .fade-leave-active for <=2.1.8 */ {
    transform: translateX(0);
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(100%);
  }
  // 我的额度展开收起动画
  // .left-enter-active, .left-leave-active {
  //   transition: all .3s ease-out;
  // }
  // .left-enter-to , .left-leave/* .fade-leave-active for <=2.1.8 */ {
  //   // transform: translateX(0);
  //   transform: translateX(100%);
  // }
  // .left-enter, .left-leave-to {
  //   // transform: translateX(100%);
  //   transform: translateX(0);
  // }
  // 我的额度
  .quotaBox {
    height: 100%;
    width: 100%;
    // display: flex;
    // flex: 1;
    flex-shrink: 0;
    // flex-shrink: 0;
    // flex-direction: column;
    .title {
      line-height: 24px;
      margin: 16px 0 8px;
      height: 22px;
      h2 {
        font-size: 18px;
        font-weight: 600;
      }
    }
    .titleFlex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      .titleIconBox {
        i {
          color: #aaa;
          font-size: 24px;
        }
      }
    }
    .talksBox {
      // height: calc(54% - 22px - 55px);
      height: 300px;
      flex: 1;
      overflow-y: auto;
      padding-right: 3px;
      position: relative;

      // /* 针对整个滚动条 */ 
      // &::-webkit-scrollbar {  
      //   width: 3px; /* 滚动条的宽度 */  
      // }
      // /* 滚动条轨道 */  
      // &::-webkit-scrollbar-track {  
      //   // background: #f1f7fe; /* 滚动条轨道的背景色 */  
      //   background: transparent;
      // } 
      // /* 滚动条滑块 */  
      // &::-webkit-scrollbar-thumb {  
      //   // background: #f1f7fe; /* 滚动条滑块的颜色 */  
      //   background: transparent;
      //   border-radius: 5px; /* 滑块边缘的圆角 */  
      // }  
      // &:hover::-webkit-scrollbar-thumb {
      //   background: rgb(238, 238, 238); 
      // }

      .payCard {
        background: #fff;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;
        .repordNum {
          font-size: 14px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
          margin-bottom: 10px;
        }
        .repordContent {
          font-size: 12px;
          line-height: 24px;
          color: #666;
        }
      }
    }
  }
  // 充值记录
  .rightBox {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  // 充值模态框
  .pay-success {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #555555;
    font-size: 16px;
    line-height: 22px;
    div {
      margin: 10px 0 40px 0;
    }
  }
  .pay-text {
    // color: #555555;
    font-size: 16px;
  }
}

</style>
